import { z } from 'zod';

export const BrandPaletteSchema = z.object({
  primary: z.string(),
  primaryForeground: z.string().optional(),
  secondary: z.string().optional(),
  secondaryForeground: z.string().optional(),
});

export const BrandSchema = z.object({
  appTitle: z.string(),
  poweredBy: z.string(),
  inputPlaceholder: z.string(),
  shortName: z.string(),
  logoUrl: z.string().nullish(),
  palette: BrandPaletteSchema.nullish(),
});

export const BrandUpdateRequestSchema = z.object({
  app_title: z.string().optional(),
  short_name: z.string().optional(),
  powered_by: z.string().optional(),
  input_placeholder: z.string().optional(),
  palette: BrandPaletteSchema.nullish(),
});

export const BrandLogoUploadRequestSchema = z.object({
  file: z.instanceof(File),
});
